<template>
  <div id="loading"></div>
</template>

<script>

import AJAX from "@/utils/AJAX.js";
export default {
  data() {
    return {
      orderString: ''
    }
  },
  created() {
    document.title = '支付中';
  },
  mounted() {
    this.getTaskSubmitInfo();
  },
  methods: {
    getTaskSubmitInfo() {
      const { id } = this.$route.query;
      AJAX.getTaskSubmitInfo({ id })
        .then((res) => {
          if (res.success) {
            this.orderString = res.result.orderString;
            setTimeout(this.startPayment, 1000);
          }
        });
    },
    isAlipay() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes('alipayclient') || ua.includes('alipay');
    },
    startPayment() {
      if (!this.isAlipay()) {
        alert('请在支付宝APP内打开此链接');
        return;
      }

      if (typeof AlipayJSBridge !== 'undefined') {
        AlipayJSBridge.call('tradePay', {
          orderStr: this.orderString
        }, async function(result) {
          if (result.resultCode === '9000') {
            alert('支付成功');
          } else {
            await alert('支付失败: ' + (result.memo || '未知错误'));
            AlipayJSBridge.call('closeWebview');
          }
        });
      } else {
        document.addEventListener('AlipayJSBridgeReady', function() {
          AlipayJSBridge.call('tradePay', {
            orderStr: this.orderString
          }, async function(result) {
            if (result.resultCode === '9000') {
              alert('支付成功');
            } else {
              await alert('支付失败: ' + (result.memo || '未知错误'));
              AlipayJSBridge.call('closeWebview');
            }
          });
        }, false);
      }
    },
  }
}
</script>

<style scoped>
  #loading {
    width: 30px;
    height: 30px;
    margin: 20px auto;
    border: 3px solid #eee;
    border-top: 3px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
</style>
